import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'windowswap';
  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      /** START : Code to Track Page View  */
      gtag('event', 'page_view', {
        page_path: event.urlAfterRedirects
      })
      /** END */
    })
  }

  public federated = {
    amazonClientId: "4a8chhdugoeq2d9oj5i4j7rkcj",
    facebookAppId: "469649824073326",
    // googleClientId: "your_google_client_id",
    oauthConfig: {
      redirectSignIn: "http://localhost:4200/",
      redirectSignOut: "http://localhost:4200/",
    }
  }

}
